import { acquisitionLabels } from '../../data/acquisition'
import type { AcquisitionChannel, DeviceKind } from '../../core/types/insights'
import type { MailSeriesKey } from '../../core/types/mail'

export const channelLabel: Record<AcquisitionChannel | 'onbekend', string> = { ...acquisitionLabels, onbekend: 'Niet ingevuld' }

export const deviceLabel: Record<DeviceKind, string> = { mobiel: 'Telefoon', desktop: 'Computer', tablet: 'Tablet' }

export const seriesLabel: Record<MailSeriesKey, string> = {
  welkom: 'Welkom',
  'verlaten-mand': 'Verlaten winkelmand',
  'bijna-op': 'Bijna op',
  review: 'Review vragen',
  'lang-niet-gezien': 'Lang niet gezien',
  verjaardag: 'Verjaardag',
}

/** 0 = zondag, 7 = zondag (ISO). */
export const weekdayLabel = (d: number) => ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'][d] ?? ''
